// import Vue from "vue";
// import VueAwesomeSwiper from "vue-awesome-swiper";
// import "swiper/dist/css/swiper.css";
// Vue.use(VueAwesomeSwiper);


// import store from "@/store/store.js";

// 主题写入store
const curTheme = localStorage.getItem("theme");
if (curTheme) {
  window.document.documentElement.setAttribute("data-theme", curTheme);
  window.localStorage.setItem("theme", curTheme);
} else {
  window.document.documentElement.setAttribute("data-theme", "day");
}

// const loginInfo = sessionStorage.getItem("ssop_user_info");

// if (loginInfo) {
//   store.commit("setLoginUser", {
//     loginUser: JSON.parse(loginInfo),
//   });
//   store.commit("setLoginToken", {
//     loginToken: true,
//   });
// } else {
//   store.commit("setLoginToken", {
//     loginToken: false,
//   });
// }
